<app-modal-title i18n>{{title}}</app-modal-title>
<app-modal-body>
    <div class="ot-m-1">
        <app-solution-form [mode]="mode" [type]="type" [solution]="selectedSolution" [environment]="selectedEnvironment" [height]="'calc(100vh - 150px)'" (formEvent)="updateSolutionForm($event)" (errorEvent)="cancel()"></app-solution-form>
    </div>
</app-modal-body>
<app-modal-footer>
    <button [id]="primaryButtonId" otsc-button color="primary" [disabled]="objectForm.invalid" (click)="submit()" i18n>
        {{primaryButton}}
    </button>
    <button id="cancel-btn" otsc-button color="secondary" (click)="cancel()" i18n>
        Cancel
    </button>
</app-modal-footer>